export function isTaxValueExclusive(taxesAndFees: number | 'inclusive' | 'exclusive') {
  return taxesAndFees === 'exclusive' || (taxesAndFees !== 'inclusive' && taxesAndFees > 0)
}

export function isTaxValueInclusive(taxesAndFees: number | 'inclusive' | 'exclusive') {
  return taxesAndFees === 'inclusive' || taxesAndFees === 0
}
